module.exports = __webpack_public_path__ + "img/hero.85ef6133.png";